import HttpData from "@/http/data/http-data";

export interface IQrServerCodeApiData {
    id: number;
    reservation_id: string;
    checksum: string;
    period_start: string;
    period_end: string;
    created_at: string;
    updated_at: string;
}

export default class QrServerCodeData extends HttpData {
    public id: number;
    public reservationId: string;
    public checksum: string;
    public periodStart: string;
    public periodEnd: string;
    public createdAt: string;
    public updatedAt: string;

    constructor(data: IQrServerCodeApiData) {
        super();

        this.id = data.id;
        this.reservationId = data.reservation_id;
        this.checksum = data.checksum;
        this.periodStart = data.period_start;
        this.periodEnd = data.period_end;
        this.createdAt = data.created_at;
        this.updatedAt = data.updated_at;
    }
}
